import React, { useContext } from "react";
import { Form } from "antd";
import { FormikContext } from "formik";
import { Input } from "antd";

function InputTextField({
  name,
  label,
  placeholder,
  className,
  type = "text",
  required = false,
  hasFeedback = false,
  ...props
}) {
  const { handleChange, handleBlur, values, errors, touched } = useContext(FormikContext);

  // render field based on type
  const renderedField = (type) => {
    switch (type) {
      case "password":
        return (
          <Input.Password
            id={name}
            name={name}
            type={type}
            placeholder={placeholder}
            onChange={handleChange}
            className={className || props?.className}
            onBlur={handleBlur}
            value={values?.[name]}
            style={{
              borderRadius: "5px",
              lineHeight: props?.style?.lineHeight ? props?.style?.lineHeight : "38px",
              marginTop: "5px"
            }}
          />
        );
      case "textArea":
        return (
          <Input.TextArea
            id={name}
            name={name}
            type={type}
            placeholder={placeholder}
            onChange={handleChange}
            className={className || props?.className}
            onBlur={handleBlur}
            value={values?.[name]}
            style={{
              borderRadius: "5px",
              lineHeight: props?.style?.lineHeight ? props?.style?.lineHeight : "38px",
              marginTop: "5px"
            }}
            {...props}
          />
        );

      default:
        return (
          <Input
            id={name}
            name={name}
            type={type}
            placeholder={placeholder}
            onChange={handleChange}
            className={props?.className}
            onBlur={handleBlur}
            value={values?.[name]}
            style={{
              ...props?.style,
              borderRadius: "5px",
              lineHeight: props?.style?.lineHeight ? props?.style?.lineHeight : "38px",
              marginTop: "5px"
            }}
            {...props}
          />
        );
    }
  };

  return (
    <>
      <Form.Item
        label={label}
        className={className}
        required={required}
        hasFeedback={hasFeedback}
        help={
          (touched?.[name] && errors?.[name]) || props?.error
            ? errors[name] || props?.error
            : undefined
        }
        validateStatus={(touched?.[name] && errors?.[name]) || props?.error ? "error" : "success"}>
        {renderedField(type)}
      </Form.Item>
    </>
  );
}

export default InputTextField;
